module.exports = __webpack_public_path__ + "img/bookmark-fill.56439ecc.png";